class SocialFeedSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-social-feed-viewport]');
    this.track = this.querySelector('[data-social-feed-track]');
    if (!this.viewport || !this.track || this.dataset.autoplay !== 'true') return;

    this.delay = Number(this.dataset.delay) || 5000;
    this.pause = false;
    this.viewport.addEventListener('pointerenter', () => (this.pause = true));
    this.viewport.addEventListener('pointerleave', () => (this.pause = false));
    this.viewport.addEventListener('focusin', () => (this.pause = true));
    this.viewport.addEventListener('focusout', () => (this.pause = false));
    this.timer = window.setInterval(() => this.advance(), this.delay);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  advance() {
    if (this.pause || document.hidden) return;
    const card = this.track.querySelector('.social-feed__card');
    const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
    const step = (card?.getBoundingClientRect().width || this.viewport.clientWidth) + gap;
    const end = this.viewport.scrollWidth - this.viewport.clientWidth;
    if (this.viewport.scrollLeft >= end - 2) {
      this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      this.viewport.scrollBy({ left: step, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('social-feed-slider')) customElements.define('social-feed-slider', SocialFeedSlider);
